import styled, { CSSProperties } from 'styled-components';

import Badge from 'components/Badge';
import ActionLink from 'components/ActionLink';
import {
  border1,
  boxShadow1,
  exactWhite,
  green,
  gray,
  red,
  lightGray,
} from '../../../../../utils/style/colors';
import { draftBackground } from '../../../../TaskListView/styles';
import Icon from '../../../../Icon';
import LocalIcon from '../../../../../ui/LocalIcon';
import { languageDirection } from '../../../../../i18n';

export const SearchIcon = styled(LocalIcon)`
  height: 100%;
  width: 100%;
  align-self: flex-start;
  cursor: pointer;
  padding: 0.5rem;
  position: absolute;
  left: 0;
  top: 0;
  transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -o-transform: translateY(-50%);
`;

export const ClearSearchIcon = styled(Icon)`
  align-self: flex-end;
  cursor: pointer;
  padding: 0.5rem;
  position: absolute;
  left: 25px;
  top: 2px;
  top: 50%;
  transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -o-transform: translateY(-50%);
`;

export const SearchWrapper = styled('div')`
  width: 150px;
  height: 35px !important;
  position: relative;
`;
export const SearchInput = styled('input')`
  background-color: ${lightGray} !important;
  border-radius: 0.75rem !important;
  border: ${border1} !important;
  width: 150px;
  height: 35px !important;
  box-sizing: border-box !important;
  font-size: 14px !important;
  margin: 0 !important;
  padding: 0 1em 0 1em !important;
  &::placeholder {
    color: #96b1ac;
  }
  &:focus {
    background-color: var(--exact-white) !important;
    border: 1px solid #34c8b6 !important;
    box-shadow: 0 0 2px #34c8b6 !important;
  }
  &:hover {
    border: 1px solid #34c8b6 !important;
  }
`;

interface IWrapperProp {
  halve: boolean;
}
interface IViewListProps {
  hiddenIfSmall?: boolean;
  embedded?: boolean;
}

interface IResponseItemIconsProps {
  loading: boolean;
}

interface IItemIconProp {
  visible?: boolean;
}

interface IItemProp {
  isActive: boolean;
  embedded?: boolean;
  draft?: boolean;
}

export const ItemIcon = styled('div')<IItemIconProp>`
  display: inline-flex;
  margin-right: 0.4em;
`;

export const LoadingStyle: React.CSSProperties = {
  width: '1.2rem',
  padding: '0',
  position: 'relative',
  alignSelf: 'auto',
  marginRight: '0.4rem',
};

export const Item = styled.li<IItemProp>`
  direction: ${(props) => props.theme.direction};
  border-bottom: ${({ embedded }) =>
    !embedded ? '1px solid #dcdcdc' : undefined};
  cursor: pointer;
  margin: ${({ embedded }) => (!embedded ? '0px 15px 0px 15px' : undefined)};
  padding: 5px 10px 5px 20px;
  position: relative;
  transition: all 0.3s ease;
  box-sizing: border-box;
  background-color: ${({ embedded }) =>
    !embedded ? 'var(--exact-white)' : undefined};
  @media only screen and (max-width: 600px) {
    ${ItemIcon} {
      visibility: visible;
    }

    margin: ${({ embedded }) => (!embedded ? '0px 15px 0px 15px' : undefined)};
    padding: 5px 10px 5px 20px;
  }

  &:hover {
    background-color: ${({ isActive }) => (isActive ? undefined : `${gray}`)};
    border-radius: 10px;

    ${ItemIcon} {
      visibility: visible;
    }
  }
  ${({ isActive, embedded, theme }) =>
    !embedded &&
    isActive &&
    `   
      border: ${border1};
      border-left: 0px
      margin: ${theme.direction === 'rtl' ? '5px 10px 5px 0px' : '5px 0px 5px 10px'};
      padding: 10px 15px 20px 25px;
      border-radius: ${theme.direction === 'rtl' ? '0px 10px 10px 0px' : '10px 0px 0px 10px'};
      background-color: ${gray};
      &:hover {
        border-radius: ${(props: any) => (props.theme.direction === 'rtl' ? '0px 10px 10px 0px' : '10px 0px 0px 10px')};
        background-color: ${gray};
      }

  `}
  ${({ draft }) =>
    draft &&
    `
  background-image: ${draftBackground}
  `}
`;

export const ItemRowPart = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
export const ItemRow = styled.li`
  min-height: ${(props) => props.isTitle && '4.5rem'};
  cursor: pointer;
  display: flex;
  position: relative;
  margin: 5px;
  width: 100%;
  transition: all 0.3s ease;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  @media only screen and (max-width: 768px) {
    flex-wrap: wrap;
  }
`;

export const SubAnswerItem = styled.li<IItemProp>`
  width: 100%;
  cursor: pointer;
  display: flex;
  padding: 10px 20px;
  position: relative;
  transition: all 0.3s ease;
  align-items: center;
  border-bottom: 1px solid #c8cee0;
  background-color: var(--exact-white);
  ${({ isActive }) =>
    !isActive &&
    `
    &:hover {
      background-color: ${gray};
    }
  `}
  ${({ isActive }) =>
    isActive &&
    `
      background-color: ${gray};
  `}
`;

export const SubAnswerItemsContainer = styled('ul')`
  width: 80%;
  margin: auto;
  border: ${border1};
  display: flex;
  border-radius: 10px;
  margin-bottom: 1rem;
  flex-direction: column;
  & > ${SubAnswerItem}:first-child {
    border-radius: 10px 10px 0 0;
  }
  & > ${SubAnswerItem}:last-child {
    border-radius: 0 0 6px 6px;
  }
`;

export const SubAnswersCounts = styled('span')`
  color: #414755;
  margin: 0 1rem;
  font-size: 13px;
`;

export const GridSubAnswerAction = styled('span')`
  display: flex;
  align-items: center;
`;

export const ResponseItemIcons = styled('span')<IResponseItemIconsProps>`
  min-height: 3rem;
  display: flex;
  align-items: center;
  flex: 1;
  flex-direction: row-reverse;
  ${({ loading }) =>
    loading &&
    `
      ${ItemIcon} {
        opacity: 0.5;
        transition: all 0.2s ease;
        visibility: visible;
        pointer-events: none;
      }
  `};
  @media only screen and (max-width: 768px) {
    justify-content: space-between;
    flex: 1;
  }
`;
interface ResponseItemsProps {
  expandable?: boolean;
}
export const ResponseItems = styled.ul<ResponseItemsProps>`
  margin: ${({ expandable }) => (expandable ? '0 10px' : '0')};
  flex: 1;
  max-height: calc(100vh - 130px);
  overflow: auto;
  padding: 0;
  direction: ${({ expandable }) =>
    expandable ? 'rtl' : 'ltr'}; // overlay not working
`;

export const ResponseListWrapper = styled('div')<IWrapperProp>`
  width: 49%;
  // margin-left: ${(props) => props.halve && '1rem'};
  display: flex;
  height: calc(100vh - 11rem);
  overflow-y: auto;
  flex-direction: column;
  @media only screen and (max-width: 600px) {
    width: 100%;
    display: ${(props) => (props.halve ? 'none' : 'flex')};
  }
`;

export const EmptyPlaceHolder = styled.div`
  margin-top: 20%;
  margin: auto;
`;

export const ViewList = styled.div<IViewListProps>`
  width: ${({ embedded }) => (embedded ? undefined : '50%')};
  height: ${({ embedded }) => (embedded ? undefined : 'calc(100vh - 150px)')};
  overflow: hidden;
  margin: ${({ embedded }) => (embedded ? undefined : '10px 0px')};
  box-shadow: ${boxShadow1};
  border-radius: ${({ embedded }) => (embedded ? '0 0 10px 10px' : '10px')};
  @media only screen and (max-width: 600px) {
    width: 100%;
    margin: 0;
  }
  @media only screen and (max-width: 600px) {
    ${(props) => (props.hiddenIfSmall ? 'display: none' : '')};
  }
`;

export const TaskListWrapper = styled.div`
  background-color: ${exactWhite};
  padding: 0.5rem 1rem;
  border: ${border1};
  border-radius: 10px;
  & > * {
    border-radius: 10px;
  }
`;
export const Wrapper = styled.div`
  height: calc(100vh - 10.5rem);
  display: flex;
  width: 100%;
  overflow: hidden;
  border: ${border1};
  box-shadow: ${boxShadow1};
  border-radius: 10px;
  background-color: var(--exact-white);
  @media only screen and (max-width: 600px) {
    height: calc(100vh - 12.5rem);
    & > div {
      padding-bottom: 1rem;
    }
  }
`;

export const Warning = styled.p`
  color: ${red};
  white-space: pre-wrap;
`;
export const Header = styled.div<IViewListProps>`
  height: 4em;
  display: flex;
  padding: 12px;
  background: ${green};
  align-items: center;
  border-radius: ${({ embedded }) => (embedded ? '0' : '10px 10px 0 0')};
  justify-content: space-between;
`;

export const Title = styled(ActionLink)`
  flex: 1;
  justify-self: flex-start;
  text-align: start;
  //height: 3rem;
  overflow: hidden;
`;

export const Bold = styled.span`
  color: var(--exact-white);
  display: inline-flex;
  position: relative;
  font-size: 13px;
  font-weight: 500;
`;

export const MyBadge = styled(Badge)`
  margin: 0.25rem 0;
  margin-inline-end: 1rem;
  //min-height: 3rem !important;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.5rem !important;
`;

export const ScoreBadge = styled(Badge)`
  margin-inline-end: 1rem;
  //min-height: 3rem !important;
  border-radius: 0.5rem !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FileAnswer = styled('div')`
  display: flex;
`;

export const FileInfo = styled('div')`
  display: flex;
  margin-inline-start: 2em;
  flex-direction: column;
  justify-content: space-around;
  & > p {
    text-align: ${(props) => props.theme.textAlign};
    word-break: break-all;
    font-weight: 500;
  }
`;

export const RelatedResponseQuestionTitle = styled('div')`
  flex: 1;
  display: flex;
  align-items: center;
`;

export const DistinctiveBadgesContainer = styled('div')`
  margin: 1rem 2rem;
  display: flex;
  float: right;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

export const ResponseListHeader = styled('div')`
  display: flex;
  margin: 1rem 1rem 0;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.1rem 1rem;
  background-color: ${green};
  border-radius: 10px;
`;

export const LoadMoreResponsesContainer = styled('div')`
  display: flex;
  margin: 1rem;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const LoadMoreText = styled('span')`
  color: #888;
  position: relative;
  font-weight: 400;
  margin-bottom: 0.5rem;
`;

export const HeaderInfo = styled('span')`
  position: relative;
  font-weight: 300;
`;

export const surveyActionButtonStyle: CSSProperties = {
  float: languageDirection() === 'rtl' ? 'left' : 'right',
};

export const ResponseCollapseItem = styled('div')`
  height: 95%;
  overflow: auto;
  padding: 1rem;
  background-color: ${gray};
`;

export const responseTitleStyle: CSSProperties = {
  flex: '1',
};

export const responseBadgeStyle: CSSProperties = {
  marginLeft: '1em',
};

export const Description = styled('div')`
  white-space: pre-wrap;
  display: flex;
  unicode-bidi: embed;
  box-shadow: ${boxShadow1};
  border-radius: 10px;
  max-width: 800px;
  width: 80%;
  margin: 0 auto;
`;

export const DoneSubmit = styled('div')`
  white-space: pre-wrap;
  unicode-bidi: embed;
  border: ${border1};
  box-shadow: ${boxShadow1};
  border-radius: 10px;
  background-color: ${green};
  color: var(--exact-white);
  width: 100%;
  display: flex;
  align-items: center;
  padding: 1rem;
`;

export const Mask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  mix-blend-mode: lighten;
  z-index: 100;
  border-radius: 0.5rem;
`;

export const ImportExportContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
`;
